import { Injectable } from '@angular/core';
import { StorageKey, StorageService } from './storage.service';
import { CookieService } from '../cookieService/cookie.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  // public MenuList: any[] = [];
  constructor(
    private storageService: StorageService,
    private cookie : CookieService
  ) {}

  logout() {
    this.storageService.clearAll();
    this.cookie.clearAllCookies();  
  }

  isTokenValid(): boolean {
    const token = this.storageService.getValue(StorageKey.authToken);
    if (!token) return false;

    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) return false;

    try {
      const decoded = JSON.parse(atob(tokenParts[1])); // Decode payload
      const currentTime = Math.floor(Date.now() / 1000);
      return decoded.exp > currentTime;
    } catch (error) {
      localStorage.clear();
      return false;
    }
  }
}
